import { __assign } from "tslib";
import * as React from 'react';
import classNames from 'classnames';
import './badge.scss';
import { Wrapper } from './Wrapper';
import { BadgeIcon } from './BadgeIcon';
export var Badge = function (_a) {
    var badge = _a.badge, size = _a.size, layout = _a.layout, background = _a.background, borderRadius = _a.borderRadius, font = _a.font, textStyle = _a.textStyle, truncateTitle = _a.truncateTitle, hideDefaultIcon = _a.hideDefaultIcon, onClick = _a.onClick, onLoadIcon = _a.onLoadIcon, httpClient = _a.httpClient;
    var backgroundClass = background ? '' : 'no-background';
    var cursorClass = onClick ? 'pointer' : '';
    var wrapperClass = classNames('wrapper', size, layout, backgroundClass, cursorClass);
    var showName = layout !== 'icon-only';
    var textClass = classNames('text', truncateTitle && 'truncated');
    var onBadgeClick = function () {
        if (onClick) {
            onClick(badge);
        }
    };
    return (React.createElement(Wrapper, { badge: badge, layout: layout },
        React.createElement("div", { onClick: onBadgeClick, className: wrapperClass, style: {
                backgroundColor: badge.backgroundColor,
                borderRadius: borderRadius + "px",
            } },
            React.createElement("div", { className: "inner" },
                React.createElement(BadgeIcon, { layout: layout, size: size, badgeIcon: badge.icon, hideDefaultIcon: hideDefaultIcon, onLoadIcon: onLoadIcon, httpClient: httpClient }),
                showName && (React.createElement("span", { className: textClass, style: __assign({ color: badge.textColor, fontFamily: font }, textStyle) }, badge.title))))));
};
//# sourceMappingURL=Badge.js.map